


















import { Mobile } from "@/mixins/mobile";
import { LineItem } from "@/models/order/order";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import SurchargeBanner from "@/components/footer/SurchargeBanner.vue";

@Component({ components: { SurchargeBanner } })
export default class CartFooter extends mixins(Mobile) {
  @Prop() items!: LineItem[];
  @Prop({ default: false }) hasQtyWarning!: boolean;

  protected handleContinueButtonClick(): void {
    this.$router.push("/checkout");
  }
}
